<template>
  <div class="row no-gutters">
    <div class="col-auto pr-3" v-if="isDentalClinic">
      <ToothSvg/>
    </div>
    <div class="col">
      <div class="d-flex gap-2 flex-wrap">
        <ToothQuantityCard  v-for="tooth in teeth"
                            :tooth="tooth"
                            :view="view"
                            :readonly="readonly"
                            :service="service"
                            :key="`t-${tooth.teeth}`"/>
      </div>
    </div>
  </div>
</template>

<script setup>
import ToothSvg from "@/assets/svg-vue/services/tooth_b.svg"
import {computed } from "vue"
import {useStore} from "vuex"
import ToothQuantityCard from "@/components/parts/patients/visit/teethTab/ToothQuantityCard.vue"

defineProps({
  readonly: Boolean,
  service: Object,
  view: {
    type: String,
    default: 'visit'
  }
})

const store = useStore()

const teeth = computed(() => store.getters.recordTeethObjects)
const isDentalClinic = computed(() => store.getters.isDentalClinic)
</script>
